export const PAYMENT_METHODS = [
  { value: "company_card", label: "Company Card" },
  { value: "personal_card", label: "Personal Card" },
  { value: "ramp", label: "Ramp" },
  { value: "cash", label: "Cash" },
  { value: "check", label: "Check" },
  { value: "ap_invoice", label: "Accounts Payable" },
];

export const paymentMethodLabel = (v) => PAYMENT_METHODS.find((p) => p.value === v)?.label || v;

// Meeting 3 — the Expense Log shows ONE status. entry_status and
// accounting_status both still exist server-side; purchasers and admins
// never see the accounting/sync side of it.
export const EXPENSE_STATUSES = [
  { value: "draft", label: "Draft" },
  { value: "pending_approval", label: "Pending Approval" },
  { value: "needs_info", label: "Needs Info" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
];

export function expenseStatus(op) {
  // The API always sends a definite approval_status (Package 41).
  return op?.approval_status || "draft";
}

// Editable (Modify) and deletable until it's approved.
export const expenseIsOpen = (op) => ["draft", "pending_approval", "needs_info", "rejected"].includes(expenseStatus(op));
